'use strict';

/* global $ */

import AudioMotionAnalyzer from 'modules/analyzer/audioMotion-analyzer';


function Player(options) {

    let opt = $.extend({
        button: options.selector+'__button',
        volume: options.selector+'__volume',
        mute: options.selector+'__mute',
        artist: options.selector+'__artist',
        title: options.selector+'__title',
        time: options.selector+'__time',
        clipboard: options.selector+'__clipboard',
    }, options);

    function initBlock(el) {
        console.log('[ Player/Init ]');
        var store = JSON.parse(sessionStorage.getItem('lradio') || {});
        var $el = $(el);
        var intervalId = null;

        if (!intervalId) {
            getCurrentTrack(opt);
            intervalId = setInterval(() => {
                getCurrentTrack(opt);
            }, 5000);
        }

        var audio = document.getElementById('audio');
        var stream = $el.attr('data-stream');
        audio.src = stream;
        audio.crossOrigin = 'anonymous';
        audio.load();
        if ($el.data('show_stream')) {
            $el.children('span').text(stream);
        }

        var canvas = document.getElementById('audioCanvas');
        if (canvas) {
            const audioMotion = new AudioMotionAnalyzer(
                canvas,
                {
                    source: audio,
                    alphaBars: true,
                    bgAlpha: 0,
                    gradient: 'lradio',
                    //ledBars: true,
                    //loRes: true,
                    mode: 4,
                    overlay: true,
                    reflexAlpha: 1,
                    reflexRatio: 0.5,
                    reflexBright: 0.8,
                    showBgcolor: false,
                    showScaleX: false,
                    smoothing: 0.3,
                    // set your preferred options here
                }
            );
            $('#audioCanvas').on('click', function() {
                if ($el.hasClass('is-played')) {
                    audioMotion.toggleFullscreen();
                }
            });
            /*
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
            var ctx = canvas.getContext("2d");

            var context = new AudioContext();
            var src = context.createMediaElementSource(audio);
            var analyser = context.createAnalyser();

            src.connect(analyser);
            analyser.connect(context.destination);
            analyser.minDecibels = -110;
            analyser.maxDecibels = 0;

            analyser.fftSize = 8192;

            var bufferLength = analyser.frequencyBinCount;
            console.log(bufferLength);

            var dataArray = new Uint8Array(bufferLength);

            var WIDTH = canvas.width;
            var HEIGHT = canvas.height;

            var barWidth = (WIDTH / bufferLength) * 4;
            console.log(barWidth);
            var barHeight;
            var x = 0;
            renderFrame();
            */
        }

        //let wave = new Wave(audio, canvas);
        // Simple example: add an animation
        //wave.addAnimation(new wave.animations.Wave());

        //wave.addAnimation(new wave.animations.Wave({
        //    lineWidth: 10,
        //    lineColor: "red",
        //    count: 20
        //}));

        /*
        wave.addAnimation(new wave.animations.Lines({
            count: 20,
            lineWidth: 5,
            //frequencyBand: 'base',
            center: true,
            mirroredY: true
        }));
        */

        /*
        wave.addAnimation(new wave.animations.Shine({
        }));

        wave.addAnimation(new wave.animations.Turntable({
            frequencyBand: 'highs',
            lineColor: '#fd7e14',
        }));
        */
        $el.find(opt.volume).on('input', function(e) {
            let volume = $(this).val() / 100;
            //console.log('[ Player/Change volume ]', volume);
            audio.volume = volume;
            $el.find(opt.mute).removeClass('m--muted m--25 m--50 m--75 m--100');
            if (volume == 0) {
                $el.find(opt.mute).addClass('m--muted');
            } else if (volume < 0.25) {
                $el.find(opt.mute).addClass('m--25');
            } else if (volume >= 0.25 && volume < 0.5) {
                $el.find(opt.mute).addClass('m--50');
            } else if (volume >= 0.5 && volume < 0.75) {
                $el.find(opt.mute).addClass('m--75');
            } else if (volume >= 0.75) {
                $el.find(opt.mute).addClass('m--100');
            }
        });
        $el.find(opt.volume).val(75).trigger('input');

        $el.find(opt.mute).on('click', function(e) {
            e.preventDefault();
            console.log('[ Player/Toggle mute ]');
            if ($(this).hasClass('m--muted')) {
                $(this).removeClass('m--muted');
                $el.find(opt.volume).trigger('input');
                audio.muted = false;
            } else {
                $el.find(opt.mute).removeClass('m--25 m--50 m--75 m--100');
                $(this).addClass('m--muted');
                audio.muted = true;
            }
        });

        $el.find(opt.button).on('click', function(e) {
            e.preventDefault();
            /*
            if (context) {
                context.resume().then(() => {
                    console.log('Playback resumed successfully');
                });
            }
            */
            console.log('[ Player/Toggle play ]');
            if ($(this).hasClass('m--play')) {
                $(this).removeClass('m--play').addClass('m--stop');
                $el.addClass('is-played');
                var stream = $el.attr('data-stream');
                var area = $el.attr('data-area');
                var localitie = $el.attr('data-localitie');
                //console.log(stream);
                audio.src = stream;
                audio.load();
                audio.play();
                audio.muted = false;
                $.getJSON('https://api.lradio.ru/statistics?stream=' + stream + '&city={"city": "' + localitie + '", "region": "' + area + '"}', function(data) {
                    console.log(data);
                });
                store.play = true;
            } else {
                $(this).removeClass('m--stop').addClass('m--play');
                $el.removeClass('is-played');
                audio.pause();
                store.play = false;
            }
            sessionStorage.setItem('lradio', JSON.stringify(store));
        });

        $el.find(opt.clipboard).on('click', function(e) {
            e.preventDefault();
            let track = $(this).attr('data-track');
            $(this).addClass('is-copied');
            setTimeout(() => $(this).removeClass('is-copied'), 2000);
            navigator.clipboard.writeText(track);
        });

        if (store.play && $el.find(opt.button).hasClass('m--play')) {
            /*
            $('body').on('click', function(e) {
                e.preventDefault();
                console.log('BLA 1');
                $el.find(opt.button).click();
                $('body').off('click');
            });
            */
        }

        function PlayMusic() {
            $el.find(opt.button).click();
        }

        function renderFrame() {
            requestAnimationFrame(renderFrame);

            var x = 10;

            analyser.getByteFrequencyData(dataArray);

            //ctx.fillStyle = 'none';
            ctx.clearRect(0, 0, WIDTH, HEIGHT);

            for (var i = 0; i < bufferLength * 0.25 - 3; i++) {
                if (x < WIDTH - 90) {
                    barHeight = dataArray[i];

                    var r = barHeight + (25 * (i/bufferLength));
                    var g = 200 * (i/bufferLength);
                    var b = 50;

                    //ctx.fillStyle = "rgba(" + r + "," + g + "," + b + ", " + barHeight / 255 + ")";
                    ctx.fillStyle = "rgba(173, 137, 253, " + barHeight / 255 + ")";
                    ctx.fillRect(x, HEIGHT / 2 - barHeight * 2, barWidth - 2, barHeight * 2 );
                    ctx.fillRect(x, HEIGHT / 2, barWidth -2, barHeight * 2 );
                    
                    x += barWidth;
                }
            }

            x = 10;

            for (var i = bufferLength * 0.25; i < bufferLength * 0.5 - 3; i++) {
                if (x < WIDTH - 90) {
                    barHeight = dataArray[i] * 0.9;

                    var r = barHeight + (25 * (i/bufferLength));
                    var g = 20;
                    var b = 250 * (i/bufferLength);

                    //ctx.fillStyle = "rgba(" + r + "," + g + "," + b + ", " + barHeight / 255 + ")";
                    ctx.fillStyle = "rgba(250, 194, 54, " + barHeight / 255 + ")";
                    ctx.fillRect(x, HEIGHT / 2 - barHeight * 2, barWidth - 2, barHeight * 2 );
                    ctx.fillRect(x, HEIGHT / 2, barWidth - 2, barHeight * 2 );

                    x += barWidth;
                }
            }

            ctx.fillStyle = '#fff';
            ctx.fillRect(0, HEIGHT / 2, WIDTH, 2);
        }

        function getCurrentTrack(opt) {
            $.getJSON('https://air.unmixed.ru/status-json.xsl', function(data) {
                let currentTrack = {};
                if (data && data.icestats) {
                    data.icestats.source.forEach((track) => {
                        if (track.listenurl.match(/\/lradio256$/)) {
                            //const trackTitleEncoded = iconv.encode(track.title, 'iso-8859-1');
                            //const trackTitleEncoded = track.title;
                            //const trackTitleEncoded = unescape(encodeURIComponent(track.title));
                            const trackTitleEncoded = decodeURIComponent(escape(track.title));
                            //const trackTitle = iconv.decode(Buffer.from(trackTitleEncoded), 'utf-8').replace("'", "\'").split('-');
                            const trackTitle = trackTitleEncoded.replace("'", "\'").split('-');

                            currentTrack.artist = trackTitle[0]?.trim() || 'L-radio';
                            currentTrack.title = trackTitle[1]?.trim() || '';
                            $(opt.artist).html(currentTrack.artist);
                            $(opt.title).html(currentTrack.title);
                            $(opt.clipboard).attr('data-track', currentTrack.artist + ' - ' + currentTrack.title);
                        }
                    });
                }
                //console.log(currentTrack);
            });
        }
    }

    $(opt.selector).each(function() {
        initBlock(this);
    });
}

export {
    Player
};
